import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("",{ moduleName: "garaje/pods/visitors/settings/email-templates/show/index/template.hbs" })